import React, { useState, useEffect } from 'react';
import InputField from '../../../../forms/inputField';
import { updateUser } from '../../../../../client/users';
import SelectSearch from '../../../../forms/selectSearch';
import { getBuyersGroupList } from '../../../../../client/areas';
import { getSubtypes } from '../../../../../client/subtypes';
import { MODALS } from '../../../../../config/images';
const ModalEditBuyer = ({
  showModal,
  user,
  onClose,
  onSave,
  setSuccessMessage,
  setShowModalSuccess 
}) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    charge: '',
    purchasingGroupId: '',
    subtypeIds: []
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [buyersGroups, setBuyersGroups] = useState([]);
  const [loadingBuyersGroups, setLoadingBuyersGroups] = useState(false);
  const [selectedBuyerGroup, setSelectedBuyerGroup] = useState(null);

  const [subtypes, setSubtypes] = useState([]);
  const [loadingSubtypes, setLoadingSubtypes] = useState(false);
  const [selectedSubtypes, setSelectedSubtypes] = useState([]);

  useEffect(() => {
    const fetchBuyersGroups = async () => {
      try {
        setLoadingBuyersGroups(true);
        
        let allGroups = [];
        
        const availableResponse = await getBuyersGroupList(false);
        allGroups = availableResponse.data.purchasingGroups || [];
        
        if (user && user.purchasingGroupId) {
          const userGroupId = user.purchasingGroupId.toString();
          const userGroupExists = allGroups.some(g => g.id.toString() === userGroupId);
          
          if (!userGroupExists) {
            try {
              const allGroupsResponse = await getBuyersGroupList();
              const userGroup = allGroupsResponse.data.purchasingGroups.find(
                g => g.id.toString() === userGroupId
              );
              
              if (userGroup) {
                allGroups = [...allGroups, userGroup];
              }
            } catch (error) {
              console.warn('No se pudo obtener el grupo del usuario:', error);
            }
          }
        }
        
        setBuyersGroups(allGroups);
        setLoadingBuyersGroups(false);
      } catch (error) {
        console.error('Error al obtener grupos de compra:', error);
        setLoadingBuyersGroups(false);
      }
    };

    if (showModal && user) {
      fetchBuyersGroups();
    }
  }, [showModal, user]);

  useEffect(() => {
    const fetchSubtypes = async () => {
      try {
        setLoadingSubtypes(true);
        const response = await getSubtypes();
        const formattedSubtypes = response.data.map(subtype => ({
          value: subtype.id.toString(),
          label: subtype.name,
          typeId: subtype.typeId
        }));
        setSubtypes(formattedSubtypes);
        setLoadingSubtypes(false);
      } catch (error) {
        console.error('Error al obtener subtipos:', error);
        setLoadingSubtypes(false);
      }
    };

    if (showModal) {
      fetchSubtypes();
    }
  }, [showModal]);


  const buyersGroupOptions = buyersGroups.map(group => ({
    value: group.id.toString(),
    label: group.group
  }));

  useEffect(() => {
    if (user) {
      
      let userSubtypeIds = [];
      if (user.subtypeIds && user.subtypeIds.length > 0) {
        userSubtypeIds = user.subtypeIds;
      } else if (user.subtype && user.subtype.length > 0) {
        userSubtypeIds = user.subtype.map(s => s.id);
      }

      setFormData({
        fullName: user.fullName || '',
        phone: user.phone || '',
        charge: user.charge || '',
        purchasingGroupId: user.purchasingGroupId || '',
        subtypeIds: userSubtypeIds
      });

      if (user.purchasingGroupId && buyersGroups.length > 0) {
        const foundGroup = buyersGroups.find(g => g.id.toString() === user.purchasingGroupId.toString());
        if (foundGroup) {
          setSelectedBuyerGroup({
            value: foundGroup.id.toString(),
            label: foundGroup.group
          });
        }
      }

      if (userSubtypeIds.length > 0 && subtypes.length > 0) {
        const selectedSubtypeOptions = subtypes.filter(subtype => 
          userSubtypeIds.includes(parseInt(subtype.value))
        );
        setSelectedSubtypes(selectedSubtypeOptions);
      }
    }
  }, [user, buyersGroups, subtypes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBuyerGroupChange = (selectedOption) => {
    setSelectedBuyerGroup(selectedOption);
    setFormData(prev => ({
      ...prev,
      purchasingGroupId: selectedOption ? selectedOption.value : ''
    }));
  };

  const handleSubtypesChange = (selectedOptions) => {
    setSelectedSubtypes(selectedOptions || []);
    
    const subtypeIds = selectedOptions ? selectedOptions.map(option => parseInt(option.value)) : [];
    
    setFormData(prev => ({
      ...prev,
      subtypeIds: subtypeIds
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const updateData = {
        roleId: 3, // Rol comprador
        name: formData.fullName,
        contact_number: formData.phone ? parseInt(formData.phone) : null,
        charge: formData.charge || null,
        purchasingGroupId: formData.purchasingGroupId ? parseInt(formData.purchasingGroupId) : null,
        subtypeIds: formData.subtypeIds || []
      };


      const response = await updateUser(user.id, updateData);
      
      if (response.status === 200) {
        setSuccessMessage('Usuario comprador actualizado correctamente');
        setShowModalSuccess(true);

        const selectedGroup = buyersGroups.find(
          group => group.id.toString() === formData.purchasingGroupId
        );

        const updatedSubtypes = selectedSubtypes.map(st => ({
          id: parseInt(st.value),
          name: st.label
        }));

        onSave({
          ...user,
          id: user.id, 
          name: formData.fullName,
          contact_number: formData.phone,
          charge: formData.charge,
          purchasingGroupId: formData.purchasingGroupId,
          purchasingGroup: selectedGroup || user.purchasingGroup,
          subtype: updatedSubtypes, 
          subtypeIds: formData.subtypeIds
        });
        onClose();
      }
    } catch (err) {
      console.error('Error al actualizar usuario:', err);
      setError(err.response?.data?.message || 'Error al actualizar el usuario');
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[90%] sm:w-[60%] md:w-[50%] lg:w-[50%] xl:w-[40%] h-[75vh] overflow-y-auto bg-white rounded-2xl">
        <div className="flex justify-end w-full p-2 ">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='px-6 pb-6'>
            <h2 className="text-2xl font-itcbold text-blue">Editar Usuario Comprador</h2>
    
            <form onSubmit={handleSubmit} className="flex flex-col gap-2 pt-4">
              <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
                <InputField
                  title="Nombre completo"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  validation="letters-only"
                  placeholder="Ingrese nombre completo"
                  horizontal={false}
                  required={true}
                />
                
                <InputField
                  title="Número de contacto"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  type="tel"
                  validation="phone"
                  placeholder="Ingrese número de contacto"
                  maxLength={9}
                  horizontal={false}
                />
      
                <InputField
                  title="Cargo"
                  name="charge"
                  value={formData.charge}
                  onChange={handleChange}
                  placeholder="Ingrese cargo"
                  horizontal={false}
                />
                

                  <SelectSearch
                    title="Grupo de compras"
                    horizontal={false}
                    name="purchasingGroupId"
                    value={selectedBuyerGroup}
                    onChange={handleBuyerGroupChange}
                    options={buyersGroupOptions}
                    placeholder="Seleccione grupo de compras"
                    isDisabled={loadingBuyersGroups}
                    isLoading={loadingBuyersGroups}
                    maxMenuHeight={100}
                  />

                <SelectSearch
                  title="Subtipo de mantenimiento"
                  name="subtypeIds"
                  value={selectedSubtypes}
                  onChange={handleSubtypesChange}
                  options={subtypes}
                  placeholder="Seleccione subtipo(s) de mantenimiento"
                  isDisabled={loadingSubtypes}
                  isLoading={loadingSubtypes}
                  horizontal={false}
                  isMulti ={true}
                />
              </div>
              
              <div className="flex items-center justify-center pt-12 space-x-3">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-gray-700 border border-gray-300 rounded-md font-itcmedium hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-white rounded-md font-itcmedium bg-blue"
                >
                  {loading ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </form>
        </div>
      </div>
    </div>
  );
};

export default ModalEditBuyer;